module.exports = __webpack_public_path__ + "img/电梯动画18.c68804e9.png";